import {
    ADD_MESSAGE_BODY,
    REMOVE_MESSAGE_FROM_MESSAGE_BODY,
    SCROLL_TOP,
    TOGGLE_CLOUD_FLARE_MODAL,
    TOGGLE_CUSTOM_SPINNER,
    TOGGLE_MODAL,
    TOGGLE_MODAL_WITH_TIMER,
    TOGGLE_NAV_BAR,
    TOGGLE_NAV_MODAL,
    TOGGLE_POPUP,
    TOGGLE_SNACKBAR,
    TOGGLE_SPINNER,
    UPDATE_AUTH_PROMO_BLOCK,
    UPDATE_CURRENT_SECTION,
    UPDATE_MESSAGES,
    UPDATE_OFAKIM_IMG_URL,
    UPDATE_REDUX,
} from 'apps/auth/actions/appAction';
import update from 'apps/auth/helpers/Immutability';

const app = (state = {}, action = {}) => {
    let mergeState;
    let newMessages = [];
    switch (action.type) {
        case UPDATE_REDUX:
            mergeState = update(state, {
                updateRedux: { $set: true },
            });
            break;
        case UPDATE_CURRENT_SECTION:
            mergeState = update(state, {
                currentSiteSection: { $set: action.currentSiteSection },
            });
            break;
        case TOGGLE_SPINNER:
            mergeState = update(state, {
                isShowSpinner: { $set: action.isShow },
            });
            break;
        case TOGGLE_CUSTOM_SPINNER:
            mergeState = update(state, {
                $auto: {
                    isShowCustomSpinner: { $set: action.isShow },
                },
            });
            break;
        case TOGGLE_MODAL:
            mergeState = update(state, {
                isShowModal: { $set: action.isShow },
                modalComponent: { $set: action.component },
            });
            break;
        case TOGGLE_MODAL_WITH_TIMER:
            mergeState = update(state, {
                isShowModalWithTimer: { $set: action.isShow },
                messageForModalWithTimer: { $set: action.message },
                onCloseForModalWithTimer: { $set: action.onCloseFunction },
            });
            break;
        case TOGGLE_CLOUD_FLARE_MODAL:
            mergeState = update(state, {
                cloudFlareModal: { $set: action.payload },
            });
            break;
        case TOGGLE_SNACKBAR:
            mergeState = update(state, {
                isShowSnackBar: { $set: action.isShow },
                messageForSnackBar: { $set: action.message },
            });
            break;
        case TOGGLE_POPUP:
            mergeState = update(state, {
                isShowPopup: { $set: action.isShow },
                popupComponent: { $set: action.component },
                canClose: { $set: action.canClose },
            });
            break;
        case TOGGLE_NAV_MODAL:
            mergeState = update(state, {
                isShowNavModal: { $set: action.isShow },
            });
            break;
        case SCROLL_TOP:
            mergeState = update(state, {
                isScroll: { $set: action.isScroll },
            });
            break;
        case TOGGLE_NAV_BAR:
            mergeState = update(state, {
                isShowNavBar: { $set: action.isShow },
            });
            break;
        case UPDATE_MESSAGES:
            mergeState = update(state, {
                messageBody: { $set: action.messages },
            });
            break;
        case ADD_MESSAGE_BODY:
            mergeState = update(state, {
                messageBody: { $push: action.message },
            });
            break;
        case UPDATE_OFAKIM_IMG_URL:
            mergeState = update(state, {
                kycDocs: {
                    $auto: {
                        [action.docId]: { $set: action.kycDoc },
                    },
                },
            });
            break;
        case UPDATE_AUTH_PROMO_BLOCK:
            mergeState = update(state, {
                authPromoAction: { $set: action.authPromoAction },
            });
            break;
        case REMOVE_MESSAGE_FROM_MESSAGE_BODY:
            newMessages = state.messageBody.filter((message) => {
                return message.messageId !== action.messageId;
            });
            mergeState = update(state, {
                messageBody: { $set: newMessages },
            });
            break;
        default:
            return state;
    }
    return mergeState;
};
export default app;
